export const bn = {
    // Navigation
    nav_home: 'হোম',
    nav_schedule: 'সময়সূচি',
    nav_tournaments: 'টুর্নামেন্ট',
    nav_series: 'সব সিরিজ',
    nav_squads: 'দলসমূহ',
    nav_players: 'খেলোয়াড়',
    nav_stats: 'পরিসংখ্যান',
    nav_matches: 'ম্যাচ',
    nav_more: 'আরো',
    nav_rankings: 'র‍্যাঙ্কিং',
    nav_champions: 'চ্যাম্পিয়নস',

    // Menu
    menu_title: 'মেনু',
    menu_profile_login: 'লগইন করুন',
    menu_go_premium: 'প্রিমিয়াম',
    menu_app_settings: 'অ্যাপ সেটিংস',
    menu_match_settings: 'ম্যাচ সেটিংস',
    menu_app_theme: 'অ্যাপ থিম',
    menu_notifications: 'নোটিফিকেশন সেটিংস',
    menu_languages: 'ভাষা',
    menu_go_premium_active: 'প্রিমিয়াম সংস্করণ আসছে',
    premium_coming_soon: 'খুব শীঘ্রই প্রিমিয়াম সংস্করণ রিলিজ হবে!',
    menu_report_problem: 'রিপোর্ট করুন',
    admin_contact_request: 'আপনি যদি এডমিন হতে চান, তবে আমাদের সাথে যোগাযোগ করুন (batchcrick@gmail.com)',
    menu_privacy_policy: 'গোপনীয়তা নীতি',
    menu_terms: 'ব্যবহারের শর্তাবলী',
    menu_terms_privacy: 'শর্তাবলী এবং গোপনীয়তা',
    menu_partner: 'অংশীদার হোন',
    menu_logout: 'লগ আউট',
    menu_select_language: 'ভাষা নির্বাচন করুন',
    language_english: 'ইংরেজি',
    language_bengali: 'বাংলা',

    // Theme
    theme_light: 'লাইট',
    theme_dark: 'ডার্ক',

    // Status
    status_success: 'সফল',
    status_error: 'ত্রুটি',
    loading: 'লোড হচ্ছে...',

    // Common
    see_all: 'সব দেখুন',
    no_data: 'কোন তথ্য নেই',

    // Cricket Terms
    runs: 'রান',
    wickets: 'উইকেট',
    overs: 'ওভার',
    run_rate: 'CRR',
    req_rate: 'RRR',
    extra: 'অতিরিক্ত',
    target: 'লক্ষ্য',
    toss: 'টস',
    won_toss: 'টসে জিতে',
    bat: 'ব্যাটিং',
    bowl: 'বোলিং',
    won_by: 'জয়ী',
    by_wickets: 'উইকেটে',
    by_runs: 'রানে',
    match_drawn: 'ম্যাচ ড্র',
    match_tied: 'ম্যাচ টাই!',
    friendly_match: 'ফ্রেন্ডলি ম্যাচ',
    player_of_match: 'ম্যাচ সেরা',

    // Status
    live: 'লাইভ',
    upcoming: 'আসন্ন',
    completed: 'সমাপ্ত',
    match_completed: 'ম্যাচ সমাপ্ত',
    innings_break: 'ইনিংস বিরতি',
    player_entering: 'খেলোয়াড় নামছেন',
    waiting_super_over: 'সুপার ওভারের জন্য অপেক্ষা করা হচ্ছে',
    result: 'ফলাফল',

    // Dynamic Messages
    need_runs_in_balls: 'এর ${balls} বলে ${runs} রান প্রয়োজন', // "{Team} er {balls} bole {runs} ran proyojon"

    // Player Roles
    batsman: 'ব্যাটার',
    bowler: 'বোলার',
    all_rounder: 'অলরাউন্ডার',
    wicket_keeper: 'উইকেট কিপার',
    captain: 'অধিনায়ক',
    vice_captain: 'সহ-অধিনায়ক',

    // Tabs & Sections
    tab_info: 'তথ্য',
    tab_live: 'লাইভ',
    tab_scorecard: 'স্কোরকার্ড',
    tab_squads: 'স্কোয়াড',
    tab_playing_xi: 'একাদশ',
    tab_graphs: 'গ্রাফ',
    tab_commentary: 'ধারাভাষ্য',
    tab_summary: 'সারাংশ',
    tab_point_table: 'পয়েন্ট তালিকা',
    tab_mvp: 'এমভিপি',

    // Stats Headers
    matches: 'ম্যাচ',
    innings: 'ইনিংস',
    average: 'গড়',
    strike_rate: 'SR',
    economy: 'Econ',
    best_bowling: 'সেরা বোলিং',
    high_score: 'সেরা রান',
    fifties: '৫০',
    hundreds: '১০০',

    // Tournaments
    organizer: 'আয়োজক',
    season: 'সিজন',
    start_date: 'শুরু',
    end_date: 'শেষ',
    groups: 'গ্রুপ',
    knockout: 'নকআউট',
    standings: 'স্ট্যান্ডিং',

    // Squads
    team_squad: 'স্কোয়াড',
    playing_xi: 'প্লেয়িং একাদশ',
    bench: 'বেঞ্চ',
    coach: 'কোচ',
    manager: 'ম্যানেজার',

    // Filters & Messages
    filter_all: 'সব',
    filter_men: 'পুরুষ',
    filter_t20: 'টি২০',
    filter_odi: 'ওডিআই',
    filter_international: 'আন্তর্জাতিক',
    no_series_found: 'কোন সিরিজ পাওয়া যায়নি',
    check_back_later: 'ক্রিকেট সিরিজের আপডেটের জন্য পরে আবার দেখুন।',

    // Players Page
    search_players: 'খেলোয়াড় খুঁজুন...',
    no_players_found: 'কোন খেলোয়াড় পাওয়া যায়নি',
    adjust_filters: 'আপনার অনুসন্ধান বা ফিল্টার পরিবর্তন করুন',

    // Squads Page
    all_batches: 'সব ব্যাচ',
    no_squads_found: 'কোন স্কোয়াড পাওয়া যায়নি',
    view_squad: 'স্কোয়াড দেখুন',

    // Auth Errors
    auth_error_wrong_password: 'ভুল পাসওয়ার্ড! আবার চেষ্টা করুন।',
    auth_error_user_not_found: 'এই ইমেইল দিয়ে কোনো অ্যাকাউন্ট পাওয়া যায়নি।',
    auth_error_invalid_email: 'ইমেইল অ্যাড্রেসটি সঠিক নয়।',
    auth_error_too_many_attempts: 'অধিকবার চেষ্টা করার কারণে অ্যাকাউন্টটি সাময়িকভাবে লক করা হয়েছে। পরে চেষ্টা করুন।',
    auth_error_generic: 'লগইন করতে সমস্যা হয়েছে। দয়া করে আপনার তথ্য যাচাই করুন।',
    auth_error_email_in_use: 'এই ইমেইলটি ইতিমধ্যে নিবন্ধিত।',
    auth_error_weak_password: 'পাসওয়ার্ডটি অন্তত ৬ অক্ষরের হতে হবে।',
    auth_error_no_permission: 'আপনার এই অ্যাপ্লিকেশনটিতে প্রবেশ করার অনুমতি নেই।',
    auth_error_unverified_email: 'লগইন করার আগে আপনাকে অবশ্যই ইমেইলটি ভেরিফাই করতে হবে। আপনার ইনবক্স চেক করুন!',
    auth_success_password_reset: 'পাসওয়ার্ড রিসেট ইমেইল পাঠানো হয়েছে!',
    auth_success_password_updated: 'পাসওয়ার্ড সফলভাবে আপডেট করা হয়েছে!',
    auth_email_reset_sent: 'পাসওয়ার্ড রিসেট ইমেইল পাঠানো হয়েছে!',
    auth_account_created: 'অ্যাকাউন্ট সফলভাবে তৈরি হয়েছে!',
    auth_locked_out: 'অধিকবার ভুল চেষ্টা! {minutes} মিনিট পর আবার চেষ্টা করুন।',
    auth_attempts_remaining: 'আর {count} বার চেষ্টা করতে পারবেন।',
    auth_wait_seconds: '{seconds} সেকেন্ড অপেক্ষা করুন...',
};
